import { useCallback, useState } from 'react';
import type { Nullable } from '@direct-frontend/stdlib';
import type { VariantsInfo } from '@/shared/api/variants';
import { getOrderVariantsInfo } from '../../api/variantsApi';
import { type GetVariantsInfoRequestParams } from '../../types/GetVariantsInfoRequestParams';

export const useGetOrderVariants = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [currentVariants, setCurrentVariants] = useState<Nullable<VariantsInfo>>(null);
    const [error, setError] = useState<unknown>(null);

    const fetchVariants = useCallback(
        async (params: GetVariantsInfoRequestParams) => {
            if (isLoading) {
                return;
            }

            try {
                setIsLoading(true);

                const result = await getOrderVariantsInfo(params);

                setCurrentVariants(result);
            } catch (error) {
                setError(error);

                throw error;
            } finally {
                setIsLoading(false);
            }
        },
        [isLoading]
    );

    const resetVariants = useCallback(() => {
        setCurrentVariants(null);
        setIsLoading(false);
        setError(null);
    }, []);

    return {
        isLoading,
        currentVariants,
        error,
        fetchVariants,
        resetVariants,
    };
};
